module.exports = __webpack_public_path__ + "static/assets/0bb4dcc699fad8f926998328af1b6c2a.png";